export default {
  methods: {
    getCardsTotalFileCount(cardId) {
      return this.$store.getters.getCardById(cardId).total_files;
    },
    increaseTotalFilesCount(cardId) {
      this.$store.dispatch('localUpdateCardField', {
        cardId,
        fieldName: 'total_files',
        fieldValue: this.getCardsTotalFileCount(cardId) + 1,
      });
    },
    decreaseTotalFilesCount(cardId) {
      this.$store.dispatch('localUpdateCardField', {
        cardId,
        fieldName: 'total_files',
        fieldValue: this.getCardsTotalFileCount(cardId) - 1,
      });
    },
    deleteAttachment(cardId, fileId) {
      if (!fileId) return;
      this.decreaseTotalFilesCount(cardId);
      this.$store.dispatch('deleteFile', { fileId, cardId }).catch(() => {
        this.increaseTotalFilesCount(cardId);
      });
    },
  },
};
